import { get, set } from 'lodash';

export const isMobile = () => /mobile\/view/.test(get(window, 'location.href'));

export const isIOS = () => /ipad|iphone|ipod/i.test(get(navigator, 'userAgent')) && !get(window, 'MSStream');

export const isMac = () => /macintosh/i.test(get(navigator, 'userAgent'));

export const isApple = () => isIOS() || isMac();

export const isMobileScreen = (mobileWidth = 641) => {
  const screenWidth = get(window, 'innerWidth');
  const screenHeight = get(window, 'innerHeight');

  return screenWidth <= mobileWidth && screenWidth / screenHeight < 1.3;
};

export const isMobileScreenDropdown = (mobileWidth = 991) => {
  const screenWidth = get(window, 'innerWidth');
  const screenHeight = get(window, 'innerHeight');

  return screenWidth <= mobileWidth && screenWidth / screenHeight < 1.3;
};

export const restoreConsole = () => {
  const i = document.createElement('iframe');
  i.style.display = 'none';
  document.body.appendChild(i);
  set(window, 'console', get(i, 'contentWindow.console', null));
};

export const ENABLE_OTA_OFFERS = true;

export const SHOULD_INCLUDE_TIP = true;

export const bannerUrlQueryMapping = {
  acmemarkets: '8yDm',
  albertsons: 'eT3h',
  andronicos: 'qFvI',
  balduccis: 's5Cs',
  carrsqc: 'TBVv',
  haggen: 'kuEK',
  jewelosco: 'tfDt',
  kingsfoodmarkets: 'PJ68',
  pavilions: 'WHlR',
  randalls: 'H77t',
  safeway: 'kO9l',
  shaws: 'clvH',
  starmarket: 'PRuZ',
  tomthumb: 'wBO4',
  vons: 'MuHG',
};

export const DELIVERY_NOTES_CHAR_COUNT = 250;
